import LairdndLogin from './lairdnd-login'
import LairdndRegistration from './lairdnd-registration'
import LairdndForgotPassword from './lairdnd-forgot-password'
import LairdndResetPassword from './lairdnd-reset-password'
import ReInputEyeIcon from './re-input-eye-icon'

export default {
    LairdndLogin,
    LairdndRegistration,
    LairdndForgotPassword,
    LairdndResetPassword,
    ReInputEyeIcon,
}
